module.exports = __webpack_public_path__ + "static/media/delete-ic-n.30fa5655.svg";